import BlocksScaleIcon from "components/icons/BlocksScaleIcon";
import { RiArrowRightFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import { useState } from "react";
import Radio from "components/radio";
import HomeBlocks from "./home-blocks";
import HomeTxs from "./home-txs";

const Home = () => {
  const [isCardOpen, setCardOpen] = useState(false);
  const [cardType, setCardType] = useState("blocks");

  const handleCardTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCardType(event.target.value);
  };

  return (
    <>
      <>
        <div className="mb-12 mt-6 grid grid-cols-1 gap-5 px-2.5 md:px-3 lg:grid-cols-2 lg:px-5">
          <div className="box overflow-hidden bg-white dark:bg-darkPrimary dark:text-white">
            <div className="mt-3 flex flex-col">
              <div className="flex w-full flex-row flex-wrap items-center justify-between gap-1 px-2.5 py-3 md:px-5">
                <div className="text-large not-italic">Latest Blocks</div>
                <button
                  className="btn-outline text-small flex gap-1"
                  onClick={() => setCardOpen(true)}
                >
                  <BlocksScaleIcon /> Customize
                </button>
              </div>
            </div>

            {/* Home Blocks */}
            <HomeBlocks />

            {/* Link to /blocks */}
            <div className="flex justify-center p-6">
              <Link to="/blocks" className="btn-outline text-small flex gap-1">
                View All Blocks
                <RiArrowRightFill />
              </Link>
            </div>
          </div>
          <div className="box overflow-hidden bg-white dark:bg-darkPrimary dark:text-white">
            <div className="mt-3 flex flex-col">
              <div className="flex w-full flex-row flex-wrap items-center justify-between gap-1 px-2.5 py-3 md:px-5">
                <div className="text-large not-italic">Latest Transactions</div>
                <button
                  className="btn-outline text-small flex gap-1"
                  onClick={() => setCardOpen(true)}
                >
                  <BlocksScaleIcon /> Customize
                </button>
              </div>
            </div>

            {/* Home Transactions */}
            <HomeTxs />

            <div className="flex justify-center p-6">
              <Link to="/txs" className="btn-outline text-small flex gap-1">
                View All Transactions
                <RiArrowRightFill />
              </Link>
            </div>
          </div>
        </div>
      </>

      {isCardOpen && (
        <div className="modal-overlay" onClick={() => setCardOpen(false)}>
          <div className="modal py-2" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <p className="text-medium px-5 py-2 !font-semibold">
                Custom Card
              </p>
            </div>
            <div className="modal-body p-5">
              <p className="text-medium mb-3 !font-semibold">Preset</p>
              <div className="grid grid-cols-2 gap-2">
                <div className="flex items-center">
                  <Radio
                    id="latest1"
                    value="blocks"
                    checked={cardType === "blocks"}
                    onChange={handleCardTypeChange}
                  />
                  <span className="ml-2">Latest Blocks</span>
                </div>
                <div className="flex items-center">
                  <Radio
                    id="latest2"
                    value="txs"
                    checked={cardType === "txs"}
                    onChange={handleCardTypeChange}
                  />
                  <span className="ml-2">Latest Transactions</span>
                </div>
                <div className="flex items-center">
                  <Radio
                    id="latest3"
                    value="status"
                    checked={cardType === "status"}
                    onChange={handleCardTypeChange}
                  />
                  <span className="ml-2">Network Status</span>
                </div>
                <div className="flex items-center">
                  <Radio
                    id="latest4"
                    value="accounts"
                    checked={cardType === "accounts"}
                    onChange={handleCardTypeChange}
                  />
                  <span className="ml-2">Account Balance</span>
                </div>
              </div>
            </div>
            <div className="mt-2 flex gap-2 px-5 py-1">
              <button
                className="btn-outline ml-auto"
                onClick={() => setCardOpen(false)}
              >
                Close
              </button>
              <button className="btn">Save Changes</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
